var pe1 = "/static/077188f1c514cd4e.png";

export { pe1 as default };
//# sourceMappingURL=pe_1.png.js.map
